import React from 'react';

export const StatsSection: React.FC = () => {
  const stats = [
    {
      number: '2500+',
      label: 'Проверенных игр',
      subtitle: 'Только лицензионные слоты',
      bgColor: 'bg-gradient-to-br from-rose-400 to-pink-500'
    },
    {
      number: '15 мин',
      label: 'Средняя скорость вывода',
      subtitle: 'В топовых казино',
      bgColor: 'bg-gradient-to-br from-purple-400 to-indigo-500'
    },
    {
      number: '₽2.5 млрд',
      label: 'Общая сумма выплат',
      subtitle: 'За 2024 год',
      bgColor: 'bg-gradient-to-br from-emerald-400 to-teal-500'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`${stat.bgColor} rounded-2xl p-8 text-white relative overflow-hidden group hover:scale-105 transition-transform duration-300`}
            >
              <div className="absolute top-6 right-6 w-10 h-10 bg-white/20 rounded-full flex items-center justify-center cursor-pointer hover:bg-white/30 transition-colors">
                <i className="ri-arrow-right-up-line text-xl"></i>
              </div>
              
              <div className="relative z-10">
                <h3 className="text-4xl font-bold mb-2 font-serif">{stat.number}</h3>
                <p className="text-lg font-medium mb-1">{stat.label}</p>
                <p className="text-sm italic opacity-90">{stat.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};